// extracted by mini-css-extract-plugin
export var bounce = "_kc-1";
export var generatingText = "_kc-6";
export var lightning = "_kc-4";
export var popup = "_kc-5";
export var progressBar = "_kc-7";
export var progressFill = "_kc-8";
export var progressShimmer = "_kc-9";
export var progressText = "_kc-a";
export var shimmer = "_kc-3";
export var uploadIcon = "_kc-0";
export var uploadingText = "_kc-2";